export const toDecimal = (num = 0) => {
  const strNum = num.toString();
  const [leftSide = '', rightSide = ''] = strNum.split('.');
  return [Number(`${leftSide}${rightSide}`), 10 ** rightSide.length];
};

export const multiply = (num_1 = 0, num_2 = 0) => {
  const [int_1, pow_1] = toDecimal(num_1);
  const [int_2, pow_2] = toDecimal(num_2);
  return (int_1 * int_2) / (pow_1 * pow_2);
};

export const divide = (num_1 = 0, num_2 = 0) => {
  const [int_1, pow_1] = toDecimal(num_1);
  const [int_2, pow_2] = toDecimal(num_2);

  const internalDivide = (a, b) => a * b ** -1; // A denominator is simply a number to the power of negative 1.

  return internalDivide(internalDivide(int_1, int_2), internalDivide(pow_1, pow_2));
};

const calculateBaseNumber = (num_1, num_2) => {
  const getRightSideLength = (num) => (num.toString().split('.')[1] || '').length;
  return 10 ** Math.max(getRightSideLength(num_1), getRightSideLength(num_2));
};

export const plus = (num_1 = 0, num_2 = 0) => {
  const baseNum = calculateBaseNumber(num_1, num_2);
  return divide(multiply(num_1, baseNum) + multiply(num_2, baseNum), baseNum);
};

export const minus = (num_1, num_2) => {
  const baseNum = calculateBaseNumber(num_1, num_2);
  return divide(multiply(num_1, baseNum) - multiply(num_2, baseNum), baseNum);
};

export const toFixed = (num = 0, precisionPoint = 0) => {
  const strNum = num.toString();
  const [leftSide, rightSide] = strNum.split('.');
  const rSide = rightSide ? `.${rightSide.slice(0, precisionPoint)}` : '';
  return Number(`${leftSide}${rSide}`);
};
